import { HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import dashboardService from './dashboards-api.config.json';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  public tenant = 'tenant1';

  constructor(private apiService: ApiService) {}

  getTenant() {
    return this.tenant;
  }

  public getMenuList() {
    return this.apiService.get(dashboardService.menuList);
  }
}
